import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from '@voicecare.ai/ui-library';
import { useOutletContext, useNavigate } from 'react-router-dom';

const QuestionSelectionStep = () => {
  const { themeMode, currentTheme, formState } = useOutletContext();
  const navigate = useNavigate();

  const currentState = formState || {};

  React.useEffect(() => {
    console.log("Question Selection - Received State (via context):", currentState);
  }, [currentState]);

  const handleNext = () => {
    const nextState = { ...currentState };
    navigate(`/call-automation-v2/file-upload`, { state: nextState });
  };

  const handleBack = () => {
    navigate(`/call-automation-v2`, { state: currentState });
  };

  return (
    <Box sx={{ padding: 2, color: themeMode === "dark" ? "#ffffff" : currentTheme?.callAutomationPage?.textColor }}>
      <Typography variant="h6" gutterBottom>
        Step 2: Select Questions
      </Typography>
      <Typography>
        This is where the question selection UI will go.
      </Typography>
      <Typography variant="caption" display="block" gutterBottom>
        Received State: {JSON.stringify(currentState)}
      </Typography>
      
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Button 
          label="Back" 
          onClick={handleBack}
        />
        
        <Button 
          label="Next" 
          onClick={handleNext}
        />
         
      </Box>
    </Box>
  );
};

export default QuestionSelectionStep; 